<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">{{$t("user.profile_setting")}}</h2>
            </div>
        </div>

        <a-card>
            <a-form :form="form"  @submit="handleSubmit" autoComplete="new-password">
                <a-row :gutter="16">
                    <a-col class="gutter-row" :span="12">
                        <div class="mb-4">
                            <a-form-item label="Name">
                                <a-input size="large" autoComplete="off"
                                    v-decorator="['name', { rules: [{ required: true, message: 'Please enter name' }], 
                                    initialValue: '' }]"
                                    placeholder="Enter name"
                                />
                            </a-form-item>
                        </div>

                        <a-row :gutter="16">
                            <a-col class="gutter-row" :span="12">
                                <div class="mb-4">
                                    <a-form-item label="Mobile">
                                        <a-input size="large"
                                            v-decorator="['mobile', { rules: [{ required: true, message: 'Please enter mobile number' }] }]"
                                            placeholder="Enter Mobile Number"
                                        >
                                            <!-- <span slot="addonBefore"> +88</span> -->
                                             <a-icon slot="prefix" type="mobile" style="color: rgba(0,0,0,.25)" />
                                        </a-input>
                                    </a-form-item>
                                </div>
                            </a-col>
                            <a-col class="gutter-row" :span="12">
                                <div class="mb-4">
                                    <a-form-item label="Email">
                                        <a-input size="large"
                                            type="email"
                                            v-decorator="['email', { rules: [{ required: false, message: 'Please enter email' }] }]"
                                            placeholder="Enter Email"
                                        />
                                    </a-form-item>
                                </div>
                            </a-col>
                        </a-row>

                        <a-row :gutter="16">
                            <a-col class="gutter-row" :span="12">
                                <div class="mb-4">
                                    <a-form-item label="Role">
                                        <a-select size="large"
                                            @change="roleSelect"
                                            show-search
                                            :filter-option="filterOption"
                                            v-decorator="['role_id', { rules: [{ required: true, message: 'Please select role' }] }]"
                                            placeholder="Select Role" style="width: 100%">
                                            <template v-for="role in roles" >
                                                <a-select-option :key="role.id" :value="role.id">
                                                    {{role.name}}
                                                </a-select-option>
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </div>
                            </a-col>

                            <a-col class="gutter-row" :span="12">
                                <div v-if="canViewHub" class="mb-4">
                                    <a-form-item label="Hub">
                                        <a-select size="large"
                                            show-search
                                            :filter-option="filterOption"
                                            v-decorator="['hub_id', { rules: [{ required: true, message: 'Please select Hub' }] }]"
                                            placeholder="Select Hub" style="width: 100%">
                                            <template v-for="hub in hubs" >
                                                <a-select-option :key="hub.id" :value="hub.id">
                                                    {{hub.name}}
                                                </a-select-option>
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </div>

                                <div v-if="canViewDevision" class="mb-4">
                                    <a-form-item label="Devision">
                                        <a-select size="large"
                                            show-search
                                            :filter-option="filterOption"
                                            v-decorator="['division_id', { rules: [{ required: true, message: 'Please select Devision' }] }]"
                                            placeholder="Select Devision" style="width: 100%">
                                            <template v-for="devision in devisions" >
                                                <a-select-option :key="devision.id" :value="devision.id">
                                                    {{devision.name_en}}
                                                </a-select-option>
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </div>

                                <div v-if="canViewAreaDevision" class="mb-4">
                                    <a-form-item label="Devision">
                                        <a-select size="large"
                                            mode="multiple"
                                            show-search
                                            :filter-option="filterOption"
                                            @change="selectAreaDevision"
                                            v-decorator="['canViewAreaDevision', { rules: [{ required: true, message: 'Please select Devision' }] }]"
                                            placeholder="Select Devision" style="width: 100%">
                                            <template v-for="devision in devisions" >
                                                <a-select-option :key="devision.id" :value="devision.id">
                                                    {{devision.name_en}}
                                                </a-select-option>
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </div>

                            </a-col>

                            <a-col v-if="canViewArea" class="gutter-row" :span="12">
                                <div class="mb-4">
                                    <a-form-item label="Area">
                                        <a-select size="large"
                                            show-search
                                            mode="multiple"
                                            :filter-option="filterOption"
                                            v-decorator="['area_ids', { rules: [{ required: true, message: 'Please select area' }] }]"
                                            placeholder="Select Devision" style="width: 100%">
                                            <template v-for="area in areas" >
                                                <a-select-option :key="area.id" :value="area.id">
                                                    {{area.name}}
                                                </a-select-option>
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </div>
                            </a-col>
                        </a-row>

                        <a-row :gutter="16">
                            <a-col class="gutter-row" :span="12">
                                <div class="mb-4">
                                    <a-form-item label="Password">
                                        <a-input size="large"
                                            type="password"
                                            v-decorator="['password', { rules: [{ required: true, message: 'Please enter password' }] }]"
                                            placeholder="Enter Password"
                                        >
                                        </a-input>
                                    </a-form-item>
                                </div>
                            </a-col>
                            <a-col class="gutter-row" :span="12">
                                <div class="mb-4">
                                    <a-form-item label="Confirm Password">
                                        <a-input size="large"
                                            type="password"
                                            v-decorator="['confirm_password', { rules: [{ required: true, message: 'Please enter password' }] }]"
                                            placeholder="Enter Password"
                                        >
                                        </a-input>
                                    </a-form-item>
                                </div>
                            </a-col>
                        </a-row>

                        <div class="mb-4">
                            <a-form-item label="Address">
                                <a-textarea
                                    v-decorator="['address', { rules: [{ required: true, message: 'Please enter address' }] }]"
                                    placeholder="Enter Address"
                                    :auto-size="{ minRows: 3, maxRows: 5 }"
                                />
                            </a-form-item>
                        </div>

                        <a-button type="primary" class="btn btn-xs" size="large" html-type="submit">
                            Add User
                        </a-button>
                    </a-col>
                    
                    <a-col class="gutter-row" :span="12">
                        <figure class="text-lg-center">
                            <img v-if="imageBase64" class="img-lg mb-3 img-avatar" :src="imageBase64" alt="User Photo">
                            <img v-else class="img-lg mb-3 img-avatar" src="../../../assets/imgs/people/User_icon.png" alt="User Photo">

                            <figcaption>
                                <!-- <a class="btn btn-light rounded font-md" href="#">
                                    <i class="icons material-icons md-backup font-md"></i> Upload
                                </a> -->
                                <a-upload style="color: red"
                                    name="file"
                                    @change="profilePreview"
                                >
                                    <a-button> <a-icon type="upload" /> Click to Upload </a-button>
                                </a-upload>
                            </figcaption>
                        </figure>
                    </a-col>
                </a-row>
            </a-form>
        </a-card>
    </div>
</template>


<script>
import { USER_STORE, GET_ROLES, HUB_LIST, DIVISION_LIST, AREA_LIST } from "../../../script/api";
import { postData, getData } from "../../../script/api-service";
import {alertPop} from "../../../script/helper";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export default {
    data() {
        return {
            imageBase64: '',
            file: '',
            roles: [],
            hubs: [],
            canViewHub: false,
            canViewDevision: false,
            devisions: [],
            canViewAreaDevision: false,
            canViewArea: false,
            areas: []
        };
    },
    methods: {
        async profilePreview({file}) {
            this.file = file.originFileObj;
            let preview = await getBase64(file.originFileObj);
            // // console.log("preview ", preview );

            this.imageBase64 = preview;
        },
        handleSubmit(e) {
            e.preventDefault();

            this.form.validateFields(async (err, values) => {
                if (!err) {
                    let data = new FormData();

                    data.append('image', this.file); 
                    data.append('confirm_password', values.confirm_password); 
                    if (values.email) data.append('email', values.email); 
                    data.append('mobile', values.mobile); 
                    data.append('name', values.name); 
                    data.append('password', values.password); 
                    data.append('role_id', values.role_id); 
                    if (values.hub_id) data.append('hub_id', values.hub_id); 
                    if (values.division_id) data.append('division_id', values.division_id); 
                    if (values.area_ids) data.append('area_ids', values.area_ids);
                    data.append('address', values.address); 

                    let res = await postData(USER_STORE, data);

                    if (res) {
                        alertPop("success", "User Created Successfully");
                        this.form.resetFields();
                        this.$router.push({ path: '/manage-user' });
                    }
                }
            });
        },
        async getRoles() {
            let res = await getData(GET_ROLES);

            if (res) {
                let masterData = res.data?.data;
                this.roles = masterData || [];
            }
        },
        async getHubs() {
            let res = await getData(HUB_LIST);

            if (res) {
                let masterData = res.data?.data;
                this.hubs = masterData || [];
            }
        },
        async getDevisions() {
            let res = await getData(DIVISION_LIST);

            if (res) {
                let masterData = res.data?.data;
                this.devisions = masterData;
            }
        },
        roleSelect(value) {
            let role = this.roles.find(e => e.id == value);
            if (role && role.hub_dependent) {
                this.canViewHub = true;
            } else this.canViewHub = false;

            if (role && role.division_dependent) {
                this.canViewDevision = true;
            } else this.canViewDevision = false;

            if (role && role.area_dependent) {
                this.canViewAreaDevision = true;
            } else {
                this.canViewArea = false;
                this.canViewAreaDevision = false;
            }
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        async getArea(devisionId) {
            let res = await getData(AREA_LIST + `?division_ids=${devisionId}`);

            if (res) {
                let masterData = res.data?.data;
                this.canViewArea = true;
                this.areas = masterData;
            }
        },
        selectAreaDevision(value) {
            this.getArea(value);
            this.form.setFieldsValue({area_ids: undefined});
            this.form.resetFields("area_ids");
        } 
    },
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: "store_user" });
    },
    mounted() {
        this.getRoles();
        this.getHubs();
        this.getDevisions();
    },
};
</script>

<style>
    .ant-upload-list {
        display: none;   
    }
</style>